import { useState } from 'react';
import { api } from '../services/api';
import type { CreateBookingRequest } from '../types';

type Stage = 'idle' | 'creating' | 'redirecting' | 'error';

export function useCreateBooking() {
  const [stage, setStage] = useState<Stage>('idle');
  const [error, setError] = useState<string | null>(null);

  async function submit(body: CreateBookingRequest) {
    try {
      setStage('creating');
      setError(null);
      const booking = await api.createBooking(body);
      setStage('redirecting');
      const payment = await api.createPayment(booking.bookingId);
      window.location.assign(payment.paymentUrl);
    } catch (e) {
      setStage('error');
      setError(e instanceof Error ? e.message : 'Erro ao criar reserva');
    }
  }

  return { stage, error, submit };
}
